import { DatabaseReference, getDatabase, ref } from '@/features/firebase/adapter/database'
import invariant from 'tiny-invariant'

class FirebaseDatabaseRefService {
    licenceToken: string | null = null
    deviceId: string | null = null

    register = (licenceToken: string, deviceId: string): void => {
        this.licenceToken = licenceToken
        this.deviceId = deviceId
    }

    orders = (): DatabaseReference => {
        this.checkRegistration()

        return ref(getDatabase(), `licences/${this.licenceToken}/serverData/orders`)
    }

    openTabs = (): DatabaseReference => {
        this.checkRegistration()

        return ref(getDatabase(), `licences/${this.licenceToken}/serverData/openTabs`)
    }

    notifications = (): DatabaseReference => {
        this.checkRegistration()

        return ref(getDatabase(), `licences/${this.licenceToken}/temporaryData/notifications`)
    }

    readNotifications = (): DatabaseReference => {
        this.checkRegistration()

        return ref(
            getDatabase(),
            `licences/${this.licenceToken}/clientData/terminal/devices/${this.deviceId}/readNotifications`
        )
    }

    private checkRegistration = (): void => {
        invariant(
            this.licenceToken && this.deviceId,
            "'licenceToken' and 'deviceId' must be registered"
        )
    }
}

export default new FirebaseDatabaseRefService()
